const SinoaInsightsPage = () => import('@/pages/sinoa_insights/SinoaInsightsPage.vue');

const routes = [
  {
    path: '/sinoa_insights/',
    meta: {
      title: 'Sinoa Insights',
    },
    component: SinoaInsightsPage,
  },
];

export default routes;
